<template>
  <div v-if="initialized" class="editor d-flex flex-column">
    <!-- <LanguageSelect v-show="isAvailable('editor.global.languages')" /> -->

    <div class="scroll-ctn">
      <v-btn class="phone-preview-btn" @click="expandPreview" icon>
        <v-icon color="primary">mdi-cellphone</v-icon>
      </v-btn>

      <div v-if="configVersion === 2">
        <div class="landing-page-header">
          {{$t('editor_landing_page_layout')}}
        </div>

        <product-informations :class="{ 'mb-4': isAvailable('editor:tabs:settings'), 'pb-0': !isAvailable('editor:tabs:settings') }"></product-informations>

      </div>

      <!-- editor.tabs.settings -->
      <!-- <div v-if="isAvailable('editor.tabs.settings') && stcTabs.length > 1">
        <div class="tab-header font-weight-bold">
          {{$t('editor_drag_tabs_info')}}
        </div>
        <img class="arrows" src="@/assets/arrange-arrow.svg">
      </div> -->

      <!-- editor.tabs.create -->
      <div v-if="isAvailable('editor:tabs:create') && !stcTabs.length" class="new-tab-button" style="text-align:center;" @click="openNewTabModal">
        {{$t('editor_new_tab_button')}}
      </div>

      <div v-if="stcTabs.length" class="tabs-ctn">
        <v-tabs show-arrows="mobile" :class="{'hide-selection': !isAvailable('editor:tabs:settings')}" v-model="activeTab">
          <draggable v-show="isAvailable('editor:tabs:settings')" class="v-tabs__container flex-shrink-1 flex-grow-0 v-slide-group__content v-tabs-bar__content" @change="onTabChange" v-model="stcTabs">
            <v-tab class="tab-name" v-for="(tab, index) in stcTabs" :key="`tab-${index}`" :href="`#tab-${index}`">
              <div class="d-flex align-center">
                <v-icon class="tab-icon">{{tab.icon}}</v-icon>
                <span class="tab-title flex-grow-1 px-7">{{ tab.name[defaultLanguage] }}</span>
                <tab-settings :tabId="tab.id" :name="tab.name[defaultLanguage]" :icon="tab.icon" v-on:delete-tab="openDeleteTabModal"></tab-settings>
              </div>
            </v-tab>
          </draggable>
          <v-tab-item class="tab-content" v-for="(tab, index) in stcTabs" :key="`tab-${index}`" :id="`tab-${index}`">
            <cms v-if="tab.type == 'cms' " :tab-id="tab.id"></cms>
            <track-and-trace v-if="tab.type == 'track-and-trace'" :tab-id="tab.id"></track-and-trace>
            <custom-html v-if="tab.type == 'custom-html'" :tab-id="tab.id"></custom-html>
          </v-tab-item>

          <!-- editor.tabs.create -->
          <div v-if="isAvailable('editor:tabs:create') && (stcTabs.length < 4 || isAdmin) && stcTabs.length > 0" class="new-tab-button" @click="openNewTabModal">
            {{$t('editor_add_new_tab_text')}} <v-icon color="rgba(7, 137, 178, 0.5)">mdi-plus-circle-outline</v-icon>
          </div>
        </v-tabs>
      </div>
    </div>

    <v-dialog v-model="newTabModal" width="500">
      <v-card>
        <v-card-title class="headline">{{$t('editor_choose_tab_template')}}</v-card-title>
        <v-card-text>
          <v-radio-group v-model="newTabType">
            <v-radio :label="$t('editor_blank_tab_template')" value="cms"></v-radio>
            <v-radio v-if="this.isAvailable('editor:tabs:track-and-trace')" :disabled="hasTrackAndTrace()" :label="$t('editor_traceability_tab_template')" value="track-and-trace"></v-radio>
            <v-radio :label="$t('editor_custom_html_tab_template')" value="custom-html"></v-radio>
            <!-- <v-radio :disabled="true" :label="$t('editor_app_download_tab_template')" value="app-download"></v-radio> -->
          </v-radio-group>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeNewTabModal">{{$t('close')}}</v-btn>
          <v-btn text @click="addNewTab" color="primary">{{$t('save')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteTabModal" width="500">
      <v-card>
        <v-card-title class="headline">{{$t('editor_remove_tab')}}</v-card-title>
        <div class="font-weight-light pa-5">
          {{$t('editor_remove_tab_description')}}
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="deleteTabModal = false" text>{{$t('close')}}</v-btn>
          <v-btn @click="deleteTab" color="red" text>{{$t('delete')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import draggable from 'vuedraggable'
import { mapGetters, mapMutations } from 'vuex'

import CMS from '@/components/editor/CMS'
import TrackAndTrace from '@/components/editor/TrackAndTrace'
import CustomHtml from '@/components/editor/CustomHtml'
import TabSettings from '@/components/TabSettings'
import ProductInformations from '@/components/ProductInformations.vue'

export default {
  name: 'EditorTab',
  components: {
    draggable,
    cms: CMS,
    TabSettings,
    'track-and-trace': TrackAndTrace,
    'custom-html': CustomHtml,
    ProductInformations
  },
  computed: {
    ...mapGetters(['initialized', 'previewLanguage', 'defaultLanguage', 'isAdmin', 'isAvailable', 'configVersion', 'editor']),

    stcTabs: {
      get () {
        return this.$store.getters.stcTabs
      },
      set (newVal) {
        this.$store.dispatch('updateTabOrder', newVal)
      }
    }
  },
  watch: {
    activeTab (newVal) {
      this.leaveEditMode()
      this.syncActiveTab()
    },
    stcTabs () {
      this.syncActiveTab()
    }
  },
  data () {
    return {
      newTabModal: false,
      deleteTabModal: false,
      selectedTabId: null,
      newTabType: 'cms',
      activeTab: 'tab-0'
    }
  },
  methods: {
    ...mapMutations({
      leaveEditMode: 'LEAVE_EDIT_MODE',
      changePreviewMode: 'CHANGE_PREVIEW_MODE',
      setPreviewLanguage: 'SET_PREVIEW_LANGUAGE',
      setActiveEditorTab: 'SET_ACTIVE_EDITOR_TAB'
    }),

    syncActiveTab () {
      const tabIndex = parseInt((this.activeTab || 'tab-0').replace('tab-', ''), 10)
      if (this.stcTabs && this.stcTabs[tabIndex]) {
        this.setActiveEditorTab(this.stcTabs[tabIndex].id)
      }
    },

    expandPreview () {
      this.changePreviewMode(true)
    },

    hasTrackAndTrace () {
      let hasTab = false
      this.stcTabs.forEach((tab) => {
        if (tab.type === 'track-and-trace') {
          hasTab = true
        }
      })
      return hasTab
    },

    onTabChange (event) {
      if (event.moved) {
        this.activeTab = `tab-${event.moved.newIndex}`
      }
    },

    openNewTabModal () {
      this.newTabModal = true
    },

    closeNewTabModal () {
      this.newTabModal = false
    },

    addNewTab () {
      // save
      this.$store.dispatch('addNewTab', { type: this.newTabType })
      this.newTabModal = false
    },

    openDeleteTabModal (id) {
      this.selectedTabId = id
      this.deleteTabModal = true
    },

    deleteTab () {
      this.$store.dispatch('deleteTab', this.selectedTabId)
      this.deleteTabModal = false
      this.selectedTabId = null
    }
  },
  mounted () {
    this.syncActiveTab()
  },
  activated () {
    if (this.initialized && this.previewLanguage !== this.defaultLanguage) {
      this.setPreviewLanguage(this.defaultLanguage)
    }
    this.syncActiveTab()
  }
}

</script>

<style scoped lang="sass">

@import '@/variables.sass'

.landing-page-header
  background: $bg-grey
  padding: 10px 0px 0px 15px
  font-weight: bold
  font-size: 14px
  margin: 0px 12px

.editor
  height: calc(100% - 52px)
  position: relative
  border-bottom: none
  margin: 0px !important
  .phone-preview-btn
    position: absolute
    top: -45px
    right: 10px
    @include lg
      display: none

.scroll-ctn
  height: 100vh
  overflow: auto
  padding-top: 10px
  &.has-language
    height: calc(100vh - 55px)
    .phone-preview-btn
      top: 8px
      right: 10px

.arrows
  width: 140px
  margin-left: 100px
  margin-top: 10px
  margin-bottom: 0px

.new-tab-button
  border: 2px dashed rgba($pastel, 0.5)
  color: rgba($pastel, 0.5)
  padding: 10px
  cursor: pointer

.v-tabs-slider-wrapper
  height: 3px !important

.hide-selection
  .v-tabs-slider-wrapper
    display: none
  ::v-deep .v-tabs-bar
    display: none

.tab-title
  color: black
  font-family: 'Roboto'
  font-size: 1rem
  letter-spacing: normal
  text-transform: none

.tab-icon
  margin-right: 10px
  g
    fill: black

.action-icon
  g
    fill: rgba(var(--primary))

.text
  display: flex

v-tab
  max-width: 200px !important

.tab-header
  color: $pastel
  padding-left: 30px

.tab-name
  cursor: grab !important

.tab-content
  // height: calc(100vh - 163px)
  // min-height: 600px

</style>
